


























































import AbpBase from "../../../lib/abpbase";
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import {GetMedList,AddBorrowMed,GetBorrowMed} from '../../../api/dialysisProcess'

import {GetListByCode} from '../../../api/configureDictionary/'


@Component({
    components:{}
})
export default class  extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;
    
    table = {
        loading:false
    }
    form:any = {
        patientId:this.data.patientId,
        dialysisSignId:this.data.dialysisSignId,
        type:null,
        itemId:null,
        itemName:null,
        quantity:null,
    }
    search:any = {
        QueryString:'',
        Type:null,
        StartDate:null,
        EndDate:null,
    }
    date = []
    rules = {
        quantity:[{required: true,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        itemId:[{required:true,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
    }
    itemOptions = []
    itemList = []
    itemLoading = false
    tabChange(){
        (this.$refs.roleForm as any).resetFields();
        (this.$refs.searchForm as any).resetFields();
        this.unitName = '单位'
        this.getData()
    }
    //
    unitName = '单位'
    created(){
        this.getData()
    }
    //药品检索
    async remoteMethodItem(query:any){
        let str = (this.$refs['setSelect'] as any).$data.query;
        if (str) {
        //赋值为空
            (this.$refs['setSelect'] as any).query = ''
        }
        this.itemOptions = [];
        if (query !== '') {
            this.itemLoading = true;
            let data = {
                queryStr:query,
            }
            let data2 = {
                QueryString:query,
                Page:1,
                PageSize:9999
            }
            let res = await GetMedList(data);
            this.itemList = res.objects;
            setTimeout(() => {
                this.itemLoading = false;
                this.itemOptions = res.objects.map((item:any) => {
                        return {
                            id: item.itemId,
                            name: item.itemName
                        }
                    });
            }, 200);
        } else {
            this.itemOptions = [];
        }
    }
    itemChange(id:any){
        this.itemList.forEach((item:any)=>{
            if(id == item.itemId){
                this.form.itemName = item.itemName;
                this.unitName = item.packingUnitName
            }
        })
        
    }
    async add(){
        this.form.type=this.tabsShow
        let res = await AddBorrowMed(this.form)
        if(res.status==1){
            this.getData();
            (this.$refs.roleForm as any).resetFields();
            (this.$refs.searchForm as any).resetFields();
            this.unitName = '单位'
        }
    }
    //左右tabs
    tabsShow = 1
    list = []
    async getData(){
        this.table.loading = true
        this.search.Type = this.tabsShow
        this.search.StartDate = this.date?this.formatDate(this.date[0]):''
        this.search.EndDate = this.date?this.formatDate(this.date[1]):''
        let res = await GetBorrowMed(this.search)
        this.list = res.objects
        this.table.loading = false
    }
    columns = [
        {
            title:'日期',
            key:''
        },
        {
            title:'药品',
            key:'itemName'
        },
        {
            title:'规格',
            key:''
        },
        {
            title:'厂商',
            key:''
        },
        {
            title:'单位',
            key:''
        },
        {
            title:'数量',
            key:'quantity'
        },
        {
            title:'操作人',
            key:''
        }
    ]
    //登陆人
    get userName(){
        return this.$store.state.session.user?this.$store.state.session.user.name:''
    }
    cancel(){
        (this.$refs.roleForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dialysisProcess/dialysisArea/borrowedMedicine.vue